export default __webpack_public_path__ + "static/logo-change-1418f9fc02ba5c2f11328fda731d3d6c.png";